import { get, toLower } from 'lodash-es'
import { pushDataLayer } from '../index'
import { PageViewLayer } from '@component/dataLayer'

export default function PageViewDataLayer() {

  return (
    <>
      <PageViewLayer data={{
        'event': 'page_view',
        'vertical': 'find an agent',
        'vertical_type': 'residential agents',
        'page_type': 'detail'
      }}></PageViewLayer>
      <PageViewLayer data={{
        'event': 'optimize.activate'
      }}></PageViewLayer>
    </>
  )
}

export function AgentListPageViewDataLayer({
  verticalType
}) {

  return (
    <PageViewLayer data={{
      'event': 'page_view',
      'vertical': 'find an agent',
      'vertical_type': toLower(verticalType),
      'page_type': 'search'
    }}></PageViewLayer>
  )
}

export function AgentReviewPageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'event': 'page_view',
      'vertical': 'find an agent',
      'vertical_type': 'agent_review',
      'page_type': 'detail'
    }}></PageViewLayer>
  )
}

export const agentDataLayer = {
  phoneClick() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Contact Agent',
      'event_interaction': 'Agent profile',
      'event_type': 'Call'
    })
    pushDataLayer({
      'event': 'agent_phone_clicks'
    })
  },

  emailClick() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Contact Agent',
      'event_interaction': 'Agent profile',
      'event_type': 'Email'
    })
  },

  requestClick(val) {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Contact Agent',
      'event_interaction': 'Agent profile',
      'event_type': `Email ${val}`
    })
  },

  listingTabClick(type, id) {

    let event = null
    switch (type) {
      case 'sale':
        event = 'click_for_sale'
        break
      case 'sold':
        event = 'click_for_sold'
        break
      case 'lease':
        event = 'click_for_lease'
        break
    }

    pushDataLayer({
      event,
      agent_id: id
    })
  }
}

export const agentCardDataLayer = {
  emailClick(agent) {
    pushDataLayer({
      'event': 'valuation_track',
      'event_category': 'Contact Agent',
      'event_action': 'Click get a free appraisal',
      'event_label': `agent_${get(agent, 'id')}`
    })
  }
}